import React from 'react';
import { Link } from 'react-router-dom'


const Home = (props) =>{
    const {handleLogout} = props;
    
    return(
        
        <section className = "hero">
            

            <header className="mb-4 shadow">
            <nav className="navbar navbar-dark bg-dark primary-styled-border">
              <div className="container">
                <h1 style={{ fontSize: '2.25rem' }}>
                  <span className="text-primary1">&lt;/&gt; </span>
                  <span style={{ color: 'white' }}>Code</span><span className="text-primary1">Zap</span>
                </h1>  
                <Link to = "/">
                    <h4>Home</h4>
                </Link>
                <Link to = "/compete">
                    <h4>Compete</h4>
                </Link>
              
                <img
                    src="/logout-icon.svg"
                    width={25}
                    height={27}
                    onClick={handleLogout}
                    style = {{cursor:"pointer"}}
                    alt = "logout"
                />
              </div>
            </nav>
          </header>
           
            

           
        </section>
        
    )
}

export default Home